import { apiGet, apiPost } from '@ibkr/clientportal.common/src/api/default'
import { protectProd } from '@ibkr/clientportal.common/src/store/getters'

const base = '';

function getIbkrAmInfo(modelcodes) {
    return apiPost(base + '/portfolio/ibkram', { modelcodes: modelcodes });
}

function getAccountSummary(acctId) {
    return apiGet(base + (protectProd() ? '/portfolio2/' : '/portfolio/') + acctId  + '/summary');
}

function getAccountLedger(acctId, model) {
    const params = (model) ? '?model=' + model : '';
    return apiGet(base + (protectProd() ? '/portfolio2/' : '/portfolio/') + acctId  + '/ledger' + params);
}

function getPortfolioAccounts() {
    return apiGet(base + (protectProd() ? '/portfolio2/' : '/portfolio/') + 'accounts');
}

function getPortfolioSubaccounts() {
    return apiGet(base + '/portfolio2/subaccounts');
}

function getModels(acctId) {
    return apiGet(base + (protectProd() ? '/portfolio2/' : '/portfolio/') + acctId + '/models');
}

function getNlv(acctId, model) {
    return apiGet(base + '/portfolio/' + acctId  + '/nlv?model=' + model);
}

function getAllPositions(acctId, simple=true) {
    return apiGet(base + '/portfolio/' + acctId  + '/positions?simple=' + simple);
}

function getPositions(acctId, model, pageId, period= '7D', sortBy = 'name', sortDir = 'a', size=30) {
    const params = `?model=${model}&sort=${sortBy}&direction=${sortDir}&period=${period}&size=${size}`;
    return apiGet(base + '/portfolio/' + acctId  + '/positions/' + pageId + params);
}

function getPortfolioPositionInfo(acctId, conid) {
    return apiGet(base + '/portfolio/' + acctId + '/position/' + conid);
}

function getPortfolioPositionsInfo(conid) {
    return apiGet(base + '/portfolio/positions/' + conid);
}

function getPositionUpdates(acctId , model, since, conids, fields = []) {
    return apiPost(base + '/portfolio/' + acctId  + '/updates?since=' + since, { model, conids, fields });
}

function getPortfolioAllocation(acctId) {
    return apiGet(base + '/portfolio/' + acctId + '/allocation');
}

function postPortfolioAllocation(acctIds, model) {
    return apiPost(base + '/portfolio/allocation', { acctIds: acctIds, model });
}

function getPortfolioPnl(acctIds) {
    return apiPost(base + '/portfolio/pnl', { acctIds: acctIds });
}

function validateAccounts(accts) {
    return apiPost(base + '/portfolio/validate', accts);
}

function invalidatePositions(acctId) {
    return apiPost(base + '/portfolio/' + acctId  + '/positions/invalidate');
}

function invalidateAllPositions() {
    return apiPost(base + '/portfolio/positions/invalidate');
}

function subscribePortfolioUpdates(acctId, refresh) {
    return apiPost(base + '/portfolio/' + acctId + '/subscribe?refresh=' + refresh);
}

function unsubscribePortfolioUpdates(acctId) {
    return apiPost(base + '/portfolio/' + acctId + '/unsubscribe');
}

function getForexPairs(conid) {
    return apiPost(base + '/portfolio/secdef', { 'conids': [conid], 'contracts': true });
}

function getAccountMeta(acctId) {
    return apiGet(base + '/portfolio/' + acctId + '/meta');
}

function getComboPositions(acctId, force) {
    return apiGet('/portfolio/' + acctId + '/combo/positions?nocache=' + (force ? true : false));
}

function getPositionMetals(acctId, model) {
    return apiGet('/portfolio/' + acctId  + '/positions/metals' + (model ? '?model=' + model : ''));
}

function getPositions2(acctId, model, sort, direction) {
    let apiPath = `/portfolio2/${acctId}/positions`;
    if (model) {
        apiPath += `?model=${model}`;
    }
    if (sort && direction) {
        apiPath += `?sort=${sort}&direction=${direction}`;
    }
    return apiGet(apiPath);
}

function getPositions3(acctId, model) {
    return apiGet('/portfolio2/' + acctId  + '/positions?model=' + model);
}

function getIbkramModelInfo(model) {
    return apiGet('/portfolio/ibkram?model=' + model);
}

function getPnlPositions(acctId, model) {
    return apiGet('/portfolio2/' + acctId  + '/pnl?model=' + model);
}

function unsubscribeAllPnl(acctId, model) {
    return apiGet('/portfolio2/' + acctId  + '/pnl/unsubscribe/all');
}

const authenticatePnl = () => {
    return apiGet(base + '/pnl/auth/init');
}

/**
 * Provides positions data and pnl for given account id and model over websocket
 */
const subscribePositions = ({ acctId, model }, { onUpdates }) => {
    if (!acctId) {
        return;
    }
    if (!window.ibrt) {
        console.error('subscribePositions: real-time api missing');
        return;
    }

    const args = { acctId, model };
    let params = 'pls+' + acctId;
    if (model) {
        params += "+" + model;
    }

    return window.ibrt.subscribeArgs(params, 'NEW_PNL', null, { onMessage: onUpdates });
}

/**
 * Unsubscribe positions data subscriptions for given account id and model
 */
const unsubscribePositions = (acctId, model) => {
    if (!acctId) {
        return;
    }
    let params = 'plu+' + acctId;
    if (model) {
        params += "+" + model;
    }
    if (window.ibrt) {
        return window.ibrt.send(params);
    } else {
        const moreParams = model ? ('?model=' + model) : '';
        return apiGet(base + '/portfolio2/' + acctId + 'pnl/unsubscribe' + moreParams);
    }
}

export default {
    authenticatePnl,
    getIbkrAmInfo,
    getModels,
    getPortfolioAccounts,
    getPortfolioSubaccounts,
    getNlv,
    getAllPositions,
    getPositions,
    getPortfolioPositionInfo,
    getPortfolioPositionsInfo,
    getPositionUpdates,
    getPortfolioAllocation,
    getPortfolioPnl,
    invalidatePositions,
    invalidateAllPositions,
    postPortfolioAllocation,
    subscribePortfolioUpdates,
    unsubscribePortfolioUpdates,
    validateAccounts,
    getForexPairs,
    getAccountSummary,
    getAccountLedger,
    getAccountMeta,
    getComboPositions,
    getPositionMetals,
    getPositions2,
    getPositions3,
    getPnlPositions,
    getIbkramModelInfo,
    subscribePositions,
    unsubscribeAllPnl,
    unsubscribePositions
}
